import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Box, { spacing, position, layout, dimensions } from 'ui-box';
import { Text } from '../../typography';
import { withTheme } from '../../theme';

var CircleIcon = function CircleIcon(_ref) {
  var size = _ref.size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
      props = _objectWithoutProperties(_ref, ["size", "fill"]);

  return React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 10 10"
  }, props), React.createElement("circle", {
    fill: fill,
    cx: "5",
    cy: "5",
    r: "5"
  }));
};

CircleIcon.displayName = "CircleIcon";
CircleIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.number
};

var Radio =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Radio, _PureComponent);

  function Radio() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Radio);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Radio)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.props.onChange(event, event.target.checked);
    });

    return _this;
  }

  _createClass(Radio, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          id = _this$props.id,
          name = _this$props.name,
          label = _this$props.label,
          disabled = _this$props.disabled,
          isInvalid = _this$props.isInvalid,
          checked = _this$props.checked,
          onChange = _this$props.onChange,
          value = _this$props.value,
          size = _this$props.size,
          isRequired = _this$props.isRequired,
          appearance = _this$props.appearance,
          props = _objectWithoutProperties(_this$props, ["theme", "id", "name", "label", "disabled", "isInvalid", "checked", "onChange", "value", "size", "isRequired", "appearance"]);

      var themedClassName = theme.getRadioClassName(appearance);
      return React.createElement(Box, _extends({
        is: "label",
        cursor: disabled ? 'not-allowed' : 'pointer',
        position: "relative",
        display: "flex",
        marginY: size === 12 ? 8 : 12
      }, props), React.createElement(Box, {
        is: "input",
        className: themedClassName,
        id: id,
        type: "radio",
        name: name,
        value: value,
        checked: checked,
        onChange: this.handleChange,
        disabled: disabled,
        "aria-invalid": isInvalid,
        required: isRequired
      }), React.createElement(Box, {
        boxSizing: "border-box",
        borderRadius: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 2,
        width: size,
        height: size
      }, React.createElement(CircleIcon, {
        size: size === 12 ? 4 : 4
      })), label && React.createElement(Text, {
        marginLeft: size === 12 ? 8 : 10,
        size: size === 12 ? 300 : 400,
        color: disabled ? 'muted' : 'default'
      }, label));
    }
  }]);

  return Radio;
}(PureComponent);

Radio.displayName = "Radio";

_defineProperty(Radio, "propTypes", _objectSpread({}, spacing.propTypes, position.propTypes, layout.propTypes, dimensions.propTypes, {
  /**
   * The id attribute of the radio.
   */
  id: PropTypes.string,

  /**
   * The name attribute of the radio.
   */
  name: PropTypes.string,

  /**
   * Label of the radio.
   */
  label: PropTypes.node,

  /**
   * The value attribute of the radio.
   */
  value: PropTypes.string,

  /**
   * Function called when state changes
   * Signature:
   * ```
   * function(event: object, checked: boolean) => void
   * ```
   */
  onChange: PropTypes.func,

  /**
   * When true, the radio is disabled.
   */
  disabled: PropTypes.bool,

  /**
   * When true, the radio is checked.
   */
  checked: PropTypes.bool,

  /**
   * The size of the radio circle. This also informs the text size and spacing.
   */
  size: PropTypes.oneOf([12, 16]),

  /**
   * When true, the radio get the required attribute.
   */
  isRequired: PropTypes.bool.isRequired,

  /**
   * When true, the aria-invalid attribute is true.
   * Used for accessibility.
   */
  isInvalid: PropTypes.bool.isRequired,

  /**
   * The appearance of the checkbox.
   * The default theme only comes with a default style.
   */
  appearance: PropTypes.string.isRequired,

  /**
   * Theme provided by ThemeProvider.
   */
  theme: PropTypes.object.isRequired
}));

_defineProperty(Radio, "defaultProps", {
  appearance: 'default',
  onChange: function onChange() {},
  size: 12,
  isRequired: false,
  isInvalid: false
});

export default withTheme(Radio);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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